import React, { useState } from "react";

const Other_details = () => {
    const [details, setdetails] = useState({data:"", flag_msg: false})

    function messagebox(msg){
        setdetails({...details, data:msg, flag_msg:(!details.flag_msg)})
        console.log("hi")
    }
    
   
    return (
        <div>
            <p onClick={() => messagebox("Projects")}> click</p>
            {details.data==="Projects" && details.flag_msg===true && <p>view</p>}
        </div>
    )
}

export default Other_details;